import { render } from "./IconGridBig.vue?vue&type=template&id=81c7bf98"
import script from "./IconGridBig.vue?vue&type=script&lang=js"
export * from "./IconGridBig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__